export default __webpack_public_path__ + "media/images/features/yado/message_cooperation-87be10d25c0cf172800dc89694bee0ee.png";